import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { getDate } from "../../../helpers/TimeDate";
import Loder from "../../loder";
import { UTCtoLocalConverter } from "../../../helpers/TimeDate";
import { PausePlan, ResumePlan } from "../../../redux/actions/PlanAction";
import { useSnackbar } from "react-simple-snackbar";
import { Tab, Nav, Dropdown } from "react-bootstrap";
import { useHistory } from "react-router-dom";

function Subscription(props) {
  const useHistorys = useHistory();
  const history = useSelector((state) => state.PlanReducer.planHistory);
  const his = useHistory();
  const [openSnackbar, closeSnackbar] = useSnackbar();
  const [status, setStatus] = useState();
  const time_zone = JSON.parse(localStorage.getItem("TIMEZONE"));
  console.log(time_zone);
  // const [pausePeriod,setPausePeriod] = useState();
  const dispatch = useDispatch();

  function monthDiff(d1, d2) {
    var months;
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    months = (date2.getFullYear() - date1.getFullYear()) * 12;
    months -= date1.getMonth();
    months += date2.getMonth();
    return months <= 0 ? 0 : months + " month";
  }

  console.log(history);
  const Pause = (data, pausePeriod) => {
    const datas = {
      learnerId: data.learner._id,
      // subscriptionId: data._id,
      pausePeriod: pausePeriod,
      timezone: time_zone.timezone,
      // status:"Paused"
    };
    const onSuccess = () => {
      his.push("/dashboard");
      window.location.reload();
      his.push("/dashboard");
    };
    const onError = (msg) => {
      openSnackbar(msg);
    };
    dispatch(PausePlan(datas, onSuccess, onError));
  };

  const Resume = (data) => {
    const datas = {
      learnerId: data.learner._id,
      // subscriptionId: data._id,
      timezone: "Asia/Calcutta",
      // status:"Running"
    };
    const onSuccess = () => {
      his.push("/dashboard");
      window.location.reload();
      his.push("/dashboard");
    };
    const onError = () => {
      alert("Something went wrong !!");
    };
    dispatch(ResumePlan(datas, onSuccess, onError));
  };

  return (
    <div className="learner_account ">
        <h4 >Subscription History</h4>
          <div>
            {history ? (
              history[0] ? (
                history.sort(a => a.status === "Paused" || a.status === "Running" ? -1 : 1).map((data, i) => (
                  <div
                    className="card mt-4"
                    style={{ height: "440px" }}
                    key={i}
                  >
                 
                    <h3 className="text-center pb-0 mb-0">
                      {data?.plan?.courseName}
                    </h3>
                    <p className="text-center top">{data.status}</p>

                    <div className="row">
                      <div className="col-6">
                        <div >
                          <p className="top mb-0">Start Date:</p>
                          <p className="bottom">
                            {data.isTimeUtc
                              ? UTCtoLocalConverter(data.startDate)
                              : getDate(data.startDate)}
                          </p>
                        </div>
                        <div >
                          <p className="top mb-0">Week Start Date:</p>
                          {data.subscriptionType == "quick_learner_mode"?
                          <p className="bottom">
                          Not applicable
                        </p>
                          :
                          <p className="bottom">
                            {data.isTimeUtc
                              ? UTCtoLocalConverter(data.weekStart)
                              : getDate(data.weekStart)}
                          </p>}
                          
                        </div>
                        <div >
                          <p className="top mb-0">Total Sessions:</p>
                          <p className="bottom">{data.totalSession}</p>
                        </div>
                        {data.subscriptionType == "quick_learner_mode" ? "" :
                          <div >
                            <p className="top mb-0">Sessions This Week:</p>
                            <p className="bottom">{data.totalWeeklySession}</p>
                          </div>}


                        <div >
                          <p className="top mb-0">Frequency:</p>
                          <p className="bottom">{`${data?.plan?.frequency} days/week`}</p>
                        </div>
                        <div >
                          <p className="top mb-0">Backlog sessions:</p>
                          <p className="bottom">{data.backlogSession}</p>
                        </div>
                      </div>

                      <div className="col-6">
                        <div className="text-right">
                          <p className="top mb-0">End Date:</p>
                          <p className="bottom">
                            {data.isTimeUtc
                              ? UTCtoLocalConverter(data.endDate)
                              : getDate(data.endDate)}
                          </p>
                        </div>
                        <div className="text-right">
                          <p className="top mb-0">Week End Date:</p>
                          {data.subscriptionType == "quick_learner_mode"?
                            <p className="bottom">Not applicable</p>
                          :
                          <p className="bottom">{getDate(data.weekEnd)}</p>}
                          
                        </div>

                        <div className="text-right">
                          <p className="top mb-0">Total Sessions Left:</p>
                          <p className="bottom">{data.availableSession}</p>
                        </div>
                        {data.subscriptionType == "quick_learner_mode" ? "" :
                          <div className="text-right">
                            <p className="top mb-0">Sessions Left This Week:</p>
                            <p className="bottom">
                              {data.availableWeeklySession}
                            </p>
                          </div>
                        }

                        <div className="text-right">
                          <p className="top mb-0">Session Cancelled:</p>
                          <p className="bottom">{data.canceledSession}</p>
                        </div>
                       
                      </div>
                    </div>
                    <p
                      className="top text-center"
                      style={{ fontWeight: "bolder", color: "red" }}
                    >
                      {data.subscriptionType == "quick_learner_mode" ? `Your ${data.availableSession} session going to expire at
                      ${data.isTimeUtc
                          ? UTCtoLocalConverter(data.endDate)
                          : getDate(data.endDate)
                        }` :
                        `Your ${data.availableWeeklySession
                        } session going to expire at ${data.isTimeUtc
                          ? UTCtoLocalConverter(data.weekEnd)
                          : getDate(data.weekEnd)
                        }`
                      }

                    </p>

                    <div className="d-flex justify-content-around">
                      {data.subscriptionType == "quick_learner_mode" ? ""
                        :
                        <div className="pause-resume-button">
                          {data.status === "Paused" ? (
                            <button
                              className="resumeButton"
                              onClick={() => Resume(data)}
                            >
                              Resume
                            </button>
                          ) : data.status === "Running" ? (
                            <Dropdown>
                              <Dropdown.Toggle
                                className="pauseButton"
                                variant="success"
                                id="dropdown-basic"
                              >
                                Pause
                              </Dropdown.Toggle>

                              <Dropdown.Menu>
                                <Dropdown.Item onClick={() => Pause(data, 7)}>
                                  7 days
                                </Dropdown.Item>

                                <Dropdown.Item onClick={() => Pause(data, 14)}>
                                  14 days
                                </Dropdown.Item>
                              </Dropdown.Menu>
                            </Dropdown>
                          ) : (
                            // <button onClick={() => Pause(data)}>Pause</button>
                            ""
                          )}
                        </div>
                      }

                      {
                        // data.currency !== "INR" || time_zone.timezone !== "Asia/Calcutta"?
                        // "":
                        <div className="upgrade-plan-button">
                        {data.status === "Running" ? (
                          data.subscriptionType == "quick_learner_mode" ? ""
                            :
                            <button
                              style={{
                                height: "40px",
                                borderRadius: "14px",
                                backgroundColor: "#4DC591",
                                border: "none",
                                color: "white",
                                padding: "8px 22px",
                                fontSize: "14px",
                              }}
                              onClick={() =>
                                useHistorys.push({
                                  pathname: "/upgradePlan",
                                  state: data,
                                })
                              }
                            >
                              Upgrade
                            </button>
                        ) : (
                          ""
                        )}
                      </div>
                      
                      }
                    
                    </div>
                    {data.status === "Running"? <p className="top text-center">Note: Plan can only be paused twice</p>:""}
                  </div>
                ))
              ) : (
                <div className="text-center">
                  Subscription Histoty not available
                </div>
              )
            ) : (
              <Loder />
            )}
          </div>
       
    </div>
  );
}

export default Subscription;
